import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  appPropertiesList: [],
  sectionTemplateData: [],
  expandedSectionTemplateData: [],
  searchEnabled: false,
  canvasSettings: {
    pixelGridColor: '#000000',
    pixelGridOpacity: '23',
    pixelGridSize: '8',
    showGuidelines: true,
    showPixelGrid: true,
    snapToPixelGrid: true,
  },
  reusableWidgets: [],
  editReusableWidget: null,
  draftedReusableWidgetList: {},
  loading: false,
  widgetSearchErrorMessage: null,
  previousPageUrlVal: null,
  showCookiesSettings: false,
  cookiesSettings: [
    {
      cookieName: 'Cookie 1',
      region: 'World Wide',
      denyCookie: false,
      title: 'About cookies on this site',
      message: `We use cookies to collect and analyze information on site performance and usage, to provide social media features and to enhance and customize content and advertisements.`,
      primaryCTA: 'Accept All',
      secondaryCTA: 'Reject All',
      showPolicyLink: false,
      policyPage: '',
      popupAnimation: 'Gentle',
      popupPosition: 'Bottom',
      okCTAStyle: 'Primary',
      declineCTAStyle: 'Neutral',
      customizeCTAStyle: 'Neutral',
      bgColour: '#F3F5F7',
      textColour: '#000000',
    },
  ],
};

const pageEditorSlice = createSlice({
  name: 'pageEditor',
  initialState,
  reducers: {
    updateAppPropertiesList(state, action) {
      state.appPropertiesList = action.payload;
    },
    updateSectionTemplateData(state, action) {
      state.sectionTemplateData = action.payload;
    },
    updateExpandedSectionTemplateData(state, action) {
      let newExpandedSectionTemplateData = [...state?.expandedSectionTemplateData];
      action?.payload?.map(template => {
        let index = newExpandedSectionTemplateData?.findIndex(
          newTemplate => newTemplate?.pageSectionId === template?.pageSectionId,
        );
        if (index > 0) {
          newExpandedSectionTemplateData?.splice(index, 1, template);
        } else {
          newExpandedSectionTemplateData?.push(template);
        }
        return null;
      });
      state.expandedSectionTemplateData = newExpandedSectionTemplateData;
    },
    updateMoreSectionTemplateData(state, action) {
         state.sectionTemplateData=action.payload;
    },
    updateCanvasSettings(state, action) {
      state.canvasSettings = action.payload;
    },
    updateCanvasSettingsSpecific(state, action) {
      state.canvasSettings[action.payload.key] = action.payload.val;
    },
    updateReusableWidgets(state, action) {
      state.reusableWidgets = action.payload;
    },
    updateLoading(state, action) {
      state.loading = action.payload;
    },
    updateEditReusableWidget(state, action) {
      state.editReusableWidget = action.payload;
    },
    updateDraftedReusableWidgetList(state, action) {
      state.draftedReusableWidgetList = action.payload;
    },
    reSetExpandedSectionTemplateData(state,action){
      state.expandedSectionTemplateData = action.payload;
    },
    resetPageEditor(state) {
      state.appPropertiesList = initialState.appPropertiesList;
      state.sectionTemplateData = initialState.sectionTemplateData;
      state.expandedSectionTemplateData = initialState.expandedSectionTemplateData;
      state.canvasSettings = initialState.canvasSettings;
      state.reusableWidgets = initialState.reusableWidgets;
      state.loading = initialState.loading;
      state.editReusableWidget = initialState.editReusableWidget;
      state.previousPageUrlVal = initialState.previousPageUrlVal;
      state.showCookiesSettings = initialState.showCookiesSettings;
      state.cookiesSettings = initialState.cookiesSettings;
    },
    updateWidgetSearchErrormsg(state, action) {
      state.widgetSearchErrorMessage = action.payload;
    },
    updateSearchEnabled(state, action) {
      state.searchEnabled = action.payload;
    },
    updatePreviousPageUrl(state,action) {
      state.previousPageUrlVal = action.payload;
    },
    toggleShowCookiesSettings(state) {
      state.showCookiesSettings = !state.showCookiesSettings;
    },
    updateCookiesSettings(state, action) {
      state.cookiesSettings = action.payload.cookiesSettings;
    },
    resetCookiesSettings(state) {
      state.cookiesSettings = [
        {
          ...state.cookiesSettings,
          title: 'About cookies on this site',
          message: `We use cookies to collect and analyze information on site performance and usage, to provide social media features and to enhance and customize content and advertisements.`,
          showPolicyLink: false,
          policyPage: '',
          popupAnimation: 'Gentle',
          popupPosition: 'Bottom',
          okCTAStyle: 'Primary',
          declineCTAStyle: 'Neutral',
          customizeCTAStyle: 'Neutral',
          bgColour: '#F3F5F7',
          textColour: '#000000',
        },
      ];
    },
  },
});

export const {
  updateAppPropertiesList,
  updateSectionTemplateData,
  updateExpandedSectionTemplateData,
  updateCanvasSettings,
  updateCanvasSettingsSpecific,
  updateReusableWidgets,
  updateLoading,
  updateEditReusableWidget,
  updateDraftedReusableWidgetList,
  resetPageEditor,
  reSetExpandedSectionTemplateData,
  updateMoreSectionTemplateData,
  updateWidgetSearchErrormsg,
  updateSearchEnabled,
  updatePreviousPageUrl,
  toggleShowCookiesSettings,
  updateCookiesSettings,
  resetCookiesSettings,
} = pageEditorSlice.actions;
export default pageEditorSlice.reducer;
